export default [
  {
    text: 'Platform',
    value: 'country.platform',
    sortable: false,
  },
  {
    text: 'Clicks',
    value: 'clicks',
    sortable: false,
  },
  {
    text: 'Commissions',
    value: 'commission',
    sortable: false,
  },
];
